//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ClusterMap from '../ClusterMap/ClusterMap';
import CheckContainer from './CheckContainer/CheckContainer';
import ECLoader from './ECLoader/ECLoader';
import Notify from '../Notify/Notify';
import CheckMap from './CheckMap/CheckMap';
import { getMobilyWiFi } from '../../api/apigeeApi';
import { useWindowSize } from '../Util/WindowResize';
import { Error } from '../Util/Util';

import './EnteredCheck.scss';

interface Props {
    rtl: boolean;
    address: string;
    coverageCheckData: Array<string>;
    ecLoading: boolean;
    notifyMe: boolean;
    dimension: any;
    dispatch: any;
    handleSearch: any;
    handleAddress: any;
}

const EnteredCheck = ({ rtl, address, coverageCheckData, ecLoading, notifyMe, dimension, dispatch, handleSearch, handleAddress }: Props) => {
    const [currentValue, setCurrentValue] = useState(1);
    const [clusterData, setClusterData] = useState([]);
    const [publicwifi, setPublicWifi] = useState(false);
    const [width, height] = useWindowSize();
    const { t } = useTranslation();

    const handleHeadingClick = (id: number) => {
        const highlight = id;
        setCurrentValue(highlight)

        if (highlight === 3) {
            setPublicWifi(true)
        } else {
            setPublicWifi(false)
            handleSearch(true, dimension);
        }
    }

    const floatDirection = rtl ? 'EC-right' : 'EC-left';

    useEffect(() => {
        if (publicwifi) {
            dispatch({ type: 'SET_LOADER', payload: true })
            getMobilyWiFi()
                .then(res => {
                    if (res.status === 200) {
                        setClusterData(res.data.features)
                        dispatch({ type: 'SET_LOADER', payload: false })
                    } else {
                        Error(res.data.fault.faultstring);
                        dispatch({ type: 'SET_LOADER', payload: false })
                    }
                }).catch(err => {
                    dispatch({ type: 'SET_LOADER', payload: false });
                    Error(err)
                })
        }
    }, [publicwifi, dispatch]);

    return (
        <React.Fragment>
            {!notifyMe ? (
                <div className='EnteredCheck' style={{ direction: rtl ? 'rtl' : 'ltr' }}>
                    <div className={`EnteredCheck__Container ${floatDirection}`} >
                        <ECLoader ecLoading={ecLoading} />
                        <div className='EC__Sections'>
                            <CheckContainer
                                rtl={rtl}
                                currentValue={currentValue}
                                coverageCheckData={coverageCheckData}
                                handleHeadingClick={handleHeadingClick}
                            />

                        </div>
                    </div>
                    {(currentValue === 1 || currentValue === 2) ? (
                        <CheckMap
                            t={t}
                            rtl={rtl}
                            placeholder={t('Search')}
                            center={dimension}
                            dispatch={dispatch}
                            handleSearch={handleSearch}
                            width={width}
                            address={address}
                            handleAddress={handleAddress}
                        />
                    ) : (
                        <ClusterMap
                            t={t}
                            rtl={rtl}
                            center={dimension}
                            placeholder={t('Search')}
                            mapClusterData={clusterData}
                            width={width}
                            handleSearch={handleSearch}
                            handleAddress={handleAddress}
                            address={address}
                        />
                    )}
                </div>
            ) : (
                <Notify rtl={rtl} center={dimension} />
            )}
        </React.Fragment>
    )

}

export default EnteredCheck